import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';
import { applyTheme, readTheme } from './lib/theme';
import { installKeyboardSync } from './lib/keyboardSync';
import { installCrashReporting } from './lib/crashReport';
import { initLiveUpdate } from './lib/liveUpdate';
import { isNative } from './lib/platform';

// Тему ставим ДО первого кадра, чтобы не мигало тёмным при светлой теме.
applyTheme(readTheme());

// Service worker в оболочке телефона НЕ нужен и вреден: он кешировал каждый
// кусок и потом вечно отдавал старое, даже после обновления файлов на диске
// (урок AssistentusApp, «ничего не изменилось после переустановки»,
// 25.06.2026). В Saleus его нет вовсе; на всякий случай снимаем любой
// когда-либо установленный и чистим кеши.
if (isNative()) {
  void (async () => {
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if (typeof caches !== 'undefined') {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (err) {
      console.warn('[boot] SW/cache flush failed', err);
    }
  })();
}

// Штамп сборки — только в консоли (Web Inspector), на экране он закрывал бы интерфейс.
console.info('[boot] build', __BUILD_TS__);

installCrashReporting();
// Клавиатура → CSS-переменная ДО первого кадра: нижние панели прилипают с первого показа.
void installKeyboardSync();
void initLiveUpdate();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
